<template>
  <div class="container">
    <wrap-container>
      <section-label
        class="section-label"
        :value="label"
        :label-color="labelColor"
      />
      <ul :class="{ numeric: numeric, 'no-margin': noMargin }">
        <li
          v-for="(val, key) in items()"
          v-bind:key="key"
          :style="{ color: itemColor }"
          v-bind:class="liClass()"
        >
          <span
            class="label"
            :class="{ 'label-light': val.labelLight }"
            v-if="val.label"
            v-html="val.label"
          />
          <p
            class="description"
            v-if="val.description"
            v-html="val.description"
          />
          <span class="detail" v-if="val.detail">
            <img src="@/assets/img/1x/0info_icon.png" alt="" />
            <span class="detail-text" v-html="val.detail" />
          </span>
        </li>
      </ul>
    </wrap-container>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import SectionLabel from "@/components/core/SectionLabel";
export default {
  name: "OfferGroup",
  components: { WrapContainer, SectionLabel },
  props: {
    label: String,
    itemColor: {
      type: String,
      default: "#535353"
    },
    labelColor: {
      type: String,
      default: "#121212"
    },
    itemIcon: {
      type: String,
      default: "azul"
    },
    noMargin: {
      type: Boolean,
      default: false
    },
    numeric: Boolean
  },
  methods: {
    items() {
      let filter = [];
      /* Filtro solo los Slots que me interesan */
      this.$slots.default.forEach(function (val) {
        if (val.componentOptions && val.componentOptions.propsData) {
          filter.push(val.componentOptions.propsData);
        }
      });
      return filter;
    },
    liClass() {
      return {
        verde: this.itemIcon === "verde" && !this.numeric
        //     azul: this.itemIcon === "azul" && !this.numeric
      };
    }
  }
};
</script>

<style scoped>
ul {
  list-style-type: none;
  white-space: normal;
  padding-left: 24px;
  margin-bottom: 40px;
}

ul li.verde:before {
  height: 12px;
  width: 12px;
  background-image: url("../../assets/img/1x/icon_ok.png");
  /* Con esto corro la imagen más a la izquierda */
  margin-left: -23px;
  padding-left: 11px;
}

ul li.azul:before {
  height: 12px;
  width: 12px;
  background-image: url("../../assets/img/1x/list_icon.png");
  /* Con esto corro la imagen más a la izquierda */
  margin-left: -23px;
  padding-left: 11px;
}

ul.numeric {
  list-style-type: decimal;
}

ul li:before {
  content: "";
  display: inline-block;
  background-size: 12px;
  background-repeat: no-repeat;
}

li {
  font-size: 14px;
  line-height: 1.57;
  margin-bottom: 30px;
}

ul.no-margin li {
  margin-bottom: 0;
}

.section-label {
  margin-bottom: 20px;
}

span.label {
  font-family: BentonSansBBVA-Medium;
  margin: 0;
}

span.label-light {
  font-family: BentonSansBBVA-Light;
}

p.description {
  margin: 0;
}

/* Elementos con detail */
span.detail {
  display: table;
  margin-top: 20px;
}

span.detail * {
  display: table-cell;
}

span.detail img {
  margin-right: 14px;
}
</style>
